export default __webpack_public_path__ + "static/media/dropdown.36b1c019.svg";